import Chart from 'chart.js/auto'

const ORANGE = 'rgb(236, 125, 39)'
const ORANGE_SEMI = 'rgb(236, 125, 39, 0.6)'
const ORANGE_LIGHT = 'rgb(250, 183, 108)'

const percentFormatter = new Intl.NumberFormat('de-DE', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

function createChartConfig(data, title) {
    return {
        type: 'bar',
        data: {
            labels: data.labels,
            datasets: [
                {
                    label: 'Aktuell',
                    data: data.values,
                    backgroundColor: data.values.map(() => ORANGE_SEMI),
                    borderColor: ORANGE_LIGHT,
                    pointRadius: 20,
                    pointBackgroundColor: ORANGE,
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: ORANGE,
                },
            ],
        },
        options: {
            indexAxis: 'y',
            scales: {
                x: {
                    min: 0,
                    max: 100,
                    ticks: {
                        callback: function (value) {
                            return value + '%'
                        },
                    },
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: title,
                },
                tooltip: {
                    enabled: true,
                    callbacks: {
                        label: function (context) {
                            if (context.parsed.x !== null) {
                                return ' ' + percentFormatter.format(context.parsed.x / 100)
                            }
                            return ''
                        },
                    },
                },
            },
            elements: {
                line: {
                    borderWidth: 3,
                },
            },
        },
    }
}

document.addEventListener('DOMContentLoaded', function () {
    let chart1El = document.querySelector('#chart1')
    let chart2El = document.querySelector('#chart2')

    if (chart1El) {
        new Chart(chart1El, createChartConfig({
            labels: [
                'Bewegung',
                'Ernährung',
                'psychische Gesundheit & Fitness',
                'Suchtprävention',
            ],
            values: JSON.parse(chart1El.dataset.dataset),
        }, 'Handlungsfelder'))
    }

    if (chart2El) {
        new Chart(chart2El, createChartConfig({
            labels: [
                'Strukturen',
                'Analyse',
                'Planung',
                'Umsetzung',
                'Evaluation',
                'Sensibilisierung',
            ],
            values: JSON.parse(chart2El.dataset.dataset),
        }, 'Gesundheitsförderungszyklus'))
    }
})
